import type {
	BrowserNotificationsTurnOnOutcomeModel,
	OpenTabAppModel,
} from '@supply-mover-2-0/web-ui';

/**
 * PD-17322 — the storefront's open-tab browser notifications (the shared
 * logic is in libs/web-ui notifications/openTabNotifications.ts).
 *
 * These names are stored in customers' browsers: changing `storagePrefix`
 * would silently turn the mode off for everyone who already turned it on.
 * Every key under it is cleared on sign-out (portalAuthStore.reset).
 */
export const PORTAL_OPEN_TAB_APP: OpenTabAppModel = {
	storagePrefix: 'workd:portal_tab_notifications:',
	lockPrefix: 'workd-portal-tab-notifications',
	tagPrefix: 'portal-notification',
};

/** The storefront's owner key: the signed-in public user. */
export function portalOpenTabOwner(publicUserId: number | null): string | null {
	return publicUserId == null ? null : String(publicUserId);
}

export const BROWSER_NOTIFICATIONS_UNAVAILABLE_MESSAGE =
	'Browser notifications are not available right now.';

/** What the settings page says when Turn on ends with nothing turned on. */
export function portalTurnOnMessage(
	reason: Extract<BrowserNotificationsTurnOnOutcomeModel, { mode: 'off' }>['reason'],
): string {
	switch (reason) {
		case 'denied':
			return 'Your browser is blocking notifications for this site. Allow them in your browser settings, then try again.';
		case 'dismissed':
			return 'Allow notifications when your browser asks to turn them on.';
		case 'unavailable':
		default:
			return BROWSER_NOTIFICATIONS_UNAVAILABLE_MESSAGE;
	}
}
